import styles from "./styles.module.scss";
import GraduateOwl from "../../assets/authLogo1.png";

const ACADEMY_URL = "https://academy.traingrc.com/p/home";

const SecondBlock = () => {
  return (
    <section className={styles.hero} aria-labelledby="solutions-heading">
      <div className={styles.heroInner}>
        <div className={styles.heroCopy}>
          <p className={styles.eyebrow}>Train GRC solutions</p>
          <h1 id="solutions-heading">
            Solutions you need. <span>Support you deserve.</span>
          </h1>
          <p className={styles.heroLead}>
            Regardless of your skill level, Train GRC is here to accelerate
            your knowledge and support your cyber risk needs.
          </p>
          <div className={styles.heroActions}>
            <a className={styles.primaryAction} href="#solution-paths">
              Find your path
              <span aria-hidden="true">↓</span>
            </a>
            <a className={styles.secondaryAction} href={ACADEMY_URL}>
              Explore the Academy
            </a>
          </div>
          <ul className={styles.heroProof} aria-label="Train GRC capabilities">
            <li>Hands-on labs</li>
            <li>Custom training</li>
            <li>Audit support</li>
          </ul>
        </div>

        <div className={styles.heroVisual}>
          <div className={styles.visualLabel}>
            <span>Learn.</span>
            <span>Build.</span>
            <span>Advise.</span>
          </div>
          <img
            src={GraduateOwl}
            alt="Train GRC graduate owl"
            width="360"
            height="442"
          />
          <p>Practical expertise for the work in front of you.</p>
        </div>
      </div>
    </section>
  );
};

export default SecondBlock;
